import { Injectable } from '@angular/core'
import { BaseService } from '@appService/base.service'
import { Observable } from 'rxjs'
import { ResponseModel } from '../api-response.model'

@Injectable({
  providedIn: 'root'
})
export class PositionService extends BaseService {
  contextPath = '/api/v1/admin/position'

  //  lấy chức vụ theo điều kiện
  postPositionList(param:any): Observable<ResponseModel<any>> {
    return this.post(`${this.contextPath}/search`, param)
  }
}
